var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.cn('inline-flex items-center gap-[4px] bg-[#F5F5F5] rounded-[12px] p-[4px] max-w-full overflow-x-auto no-scrollbar', _vm.$props.class)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }